<template>
    <section id="common_banner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="common_bannner_text">
                        <h2>Booking submission</h2>
                        <ul>
                            <li><router-link to="/">Home</router-link>
                            </li>
                            <li><span><i class="fas fa-circle"></i></span><router-link
                                    to="/tour-search">Tours</router-link></li>
                            <li><span><i class="fas fa-circle"></i></span><router-link to="/tour-details">Amazon
                                    tour</router-link>
                            </li>
                            <li><span><i class="fas fa-circle"></i></span> Booking</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "TourBookingSubBanner"
};
</script>